import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
})
export class WarningComponent {
  @Input() fields = [];

  constructor(public modal: NgbActiveModal) { }

  navigateField(field: any): void {
    this.modal.close(field);
  }
}
